/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Text } from 'components/Text';
import { Col, Row } from "components/Grid";
import { NotesAccordion } from "components";
import { Content, LayoutCircle, Section, Spacer, Label1, VerticalGapContent, Text1 } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';

const ClaimsSummary = ({ stage, idOperation }) => {
  const [summary, setSummary] = useState({});
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const isClient = authContext.enumProfile === 1 ? true : false;
  const [isStatusNew, setIsStatusNew] = useState(null);

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(idOperation)
      .then(response => response.json())
      .then(response => {
        setIsStatusNew(response.idDomainStatus === 249);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  useEffect(() => {
    getOperationInfo()
  }, []);

  const checkOperationRoute = (idOperation, step) => {
    if (stage === step) return;

    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      loading.stop();
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      let { route } = res.ret_value;

      if (step !== 3 || route) {
        if (step === 1) history.push(`/edit-claim/${idOperation}`);

        if ((step === 2 || step === 3) && isStatusNew) {
          return;
        } else if (step === 2) {
          history.push(`/claim-composition/${idOperation}`)
        }

        if (step === 3) history.push({ pathname: route })
      } else {
        loading.stop();
      }
    }).catch(e => loading.stop());
  }

  function handleSummary() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderClaims(idOperation)
      .then(response => response.json()).then(data => {
        setSummary({
          referenceNumber: data.ret_value.referenceNumber,
          broker: data.ret_value.broker,
          client: data.ret_value.client,
          ucr: data.ret_value.ucr,
          office: data.ret_value.office,
          ecfTransaction: data.ret_value.ecfTransaction,
          description: data.ret_value.description
        });
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  const goToLoginPage = () => history.push('/login');

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    } else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };
    handleSummary();
  }, []);

  return (
    <>
      <Content>
        <Section>
          <LayoutCircle isActive={stage === 1} onClick={() => checkOperationRoute(idOperation, 1)}> 1 </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>FNOL</Text>
        </Section>

        <Spacer className="d-sm-none"></Spacer>
        <Section>
          <LayoutCircle isActive={stage === 2} onClick={() => checkOperationRoute(idOperation, 2)}> 2 </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>ON-GOING</Text>
        </Section>

        <Spacer className="d-sm-none"></Spacer>
        <Section>
          <LayoutCircle isActive={stage === 3} onClick={() => checkOperationRoute(idOperation, 3)}> 3 </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>BINDING</Text>
        </Section>
      </Content>


      <VerticalGapContent>
        {stage !== 1
          ? (
            <>
              <Row>
                <Col sm={4} className="pl-sm-4">
                  <Label1>Reference Number</Label1>
                  <Text1>{summary.referenceNumber}</Text1>

                  <Label1>Broker</Label1>
                  <Text1>{summary.broker}</Text1>
                </Col>
                <Col sm={4} className="pl-sm-4">
                  <Label1>Client</Label1>
                  <Text1>{summary.client}</Text1>

                  <Label1>UCR</Label1>
                  <Text1>{summary.ucr}</Text1>
                </Col>
                <Col sm={4} className="pl-sm-4">
                  <Label1>Office</Label1>
                  <Text1>{summary.office}</Text1>

                  <Label1>ECF Transaction</Label1>
                  <Text1>{summary.ecfTransaction}</Text1>
                </Col>
              </Row>
              {/* <Row>
                <Col sm={4} className="pl-sm-4">
                  <Label1>Description</Label1>
                  <Text1>{summary.description}</Text1>
                </Col>
              </Row> */}
            </>
          ) : null}
        <Row sm={12} md={12}>
          {(idOperation && !isClient) && <NotesAccordion
            title="Notes"
            idOperation={idOperation}
          />}
        </Row>
      </VerticalGapContent>


    </>
  )
}

export default ClaimsSummary;
